import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export const KycVerificationCtasValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    configService?: ConfigService,
  ) => Observable<any>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.VERIFICATION_EDIT_INFORMATION,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri?: UiZoneWidgetAttributeConfig) => {
      const data = store.select(ProfileState.getProfile);

      return data.subscribe({
        next: (res) => {
          const key = attri?.['buttonActionType'] as string;
          ctaButtonSignalService.setSignal({
            [key]: true,
          });
        },
      });
    },
  ],
]);
